import React, {useEffect, useState} from "react";
import * as XLSX from 'xlsx'
import {Colors} from "../assets/colors/Colors";
import Tooltip from "@mui/material/Tooltip";
import {isEmpty} from "../util/is";


const ExcelToJSON = ({identificador, handleChange, titleTooltip = 'Importar Excel', icon = 'fa-file-upload', color}) => {

  const [state, setState] = useState({
    hoja: "",
    hojas:[],
    [identificador]: null
  })

  const handleInputChange = event => {
    try {
      const target = event.target
      const value = target.type === 'checkbox' ? target.checked : target.value
      let hojas = [];
      if (identificador) {
        let reader = new FileReader()
        reader.readAsArrayBuffer(target.files[0])
        reader.onloadend = (e) => {
          let data = new Uint8Array(e.target.result);
          let workbook = XLSX.read(data, {type: 'array'}); 

          workbook.SheetNames.forEach(function (sheetName) {
            // Here is your object
            let XL_row_object = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName], {defval: ""});
            let data = []
            XL_row_object.forEach(object => {
              let obj = {}
              Object.keys(object).forEach(key =>{
                obj[key] = object[key].toString().trim()
              })
              data.push(obj)
            })
            hojas.push({
              data: data,
              sheetName
            })
          })
          setState({
            ...state,
            [identificador]: target.files[0].name,
            selectedFileDocument: target.files[0],
            hojas
          })
          handleChange(hojas, target.files[0]);
          event.target.value = null;
        }
      }
    }
    catch (e) {
      setState({
        ...state,
        [identificador]: null
      })
      event.target.value = null;
    }
  }

  return(

    <Tooltip title={isEmpty(state[identificador]) ? titleTooltip : state[identificador]}>

      <span className="icon-container-actions d-flex align-items-center">
                <div style={{backgroundColor: color ? color : isEmpty(state[identificador]) ? Colors.RED_SWITCH_INACTIVE : Colors.GREEN_SWITCH_ACTIVE}}
                />
                <input
                  required
                  type="file"
                  name={identificador}
                  id={identificador}
                  onChange={handleInputChange}
                  className="inputfile"
                />
                <label htmlFor={identificador} style={{color: color ? color : isEmpty(state[identificador]) ? Colors.RED_SWITCH_INACTIVE : Colors.GREEN_SWITCH_ACTIVE}} className={`fas ${icon} fa-2x`}/>
      </span>

    </Tooltip>

  )

}

export default ExcelToJSON;
